export default __webpack_public_path__ + "static/media/cg_wide_map_big.14f62d59.png";